import { useMotionValue, useViewportScroll as framerUseViewportScroll } from 'framer-motion';
import { useIsomorphicLayoutEffect } from 'react-use';
import { useGlobalContext } from 'store/GlobalProvider';

export function useViewportScroll() {
  const { savedScrollTop } = useGlobalContext();
  const fakeScroll = useMotionValue(savedScrollTop);
  const { scrollY } = framerUseViewportScroll();

  useIsomorphicLayoutEffect(() => {
    fakeScroll.set(savedScrollTop);
  }, [savedScrollTop]);

  return savedScrollTop === 0 ? scrollY : fakeScroll;
}
